import createSagaMiddleware from "redux-saga";

import * as filterActions from "./actions/filters";
import * as ajaxActions from "./actions/ajax";
import * as routerActions from "./actions/router";
import * as slideDeckActions from "./actions/slide_decks";

export const sagaMiddleware = createSagaMiddleware();

// Adds router related metadata to the action. Whether the section or tab has changed.
export const routerSectionChangedMiddleware = store => next => action => {
  const state = store.getState();
  const storedSectionSlug = state.router.params.section;
  const storedTabSlug = state.router.params.tab;
  let sectionSlug, tabSlug;

  if (action.type === routerActions.ROUTER_LOCATION_CHANGED) {
    sectionSlug = action.payload.pathname.split("/")[1];
    tabSlug = action.payload.pathname.split("/")[3];
    action.sectionChanged = storedSectionSlug !== sectionSlug;
    action.tabChanged = storedTabSlug !== tabSlug;
  } else {
    sectionSlug = storedSectionSlug;
    tabSlug = storedTabSlug;
  }

  action.sectionSlug = sectionSlug;
  action.tabSlug = tabSlug;

  return next(action);
};

// responsible for dispatching an AJAX action to the server if the user's action requires it.
// sagas.js will then intercept that action and perform the actual async request and store update.
export const ajaxRequestMiddleware = store => next => action => {
  const extraSlideDeckActions = [
    slideDeckActions.CHART_SLIDE_DECK_BUTTON_CLICKED,
    slideDeckActions.SUBMIT_SLIDE_DECK_BUTTON_CLICKED,
  ];
  const slideDeckRequestAjaxRequired = extraSlideDeckActions.find(t => t === action.type);

  const extraActions = [
    routerActions.ROUTER_LOCATION_CHANGED
  ];
  const actionTypesThatTriggerAServerMessage = Object.keys(filterActions).concat(extraActions);
  const dataRequestAjaxRequired = actionTypesThatTriggerAServerMessage.find(t => t === action.type);

  const actionRequiresServerMessage = dataRequestAjaxRequired || slideDeckRequestAjaxRequired;
  if (!actionRequiresServerMessage) { return next(action); }

  const result = next(action);
  const newState = store.getState();

  if (dataRequestAjaxRequired) {
    store.dispatch(ajaxActions.dataRequestAjaxAction(newState, action));
  } else {
    store.dispatch(ajaxActions.slideDeckRequestAjaxAction(newState, action));
  }

  return result;
};

export const loggingMiddleware = () => next => action => {
  // console.log(action.type);

  return next(action);
};
